import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import Divider from '@mui/material/Divider';
import Color from '../../Style/Color';
import { Typography } from '../../';
var StyledComponent = styled(function (props) {
    var id = props.id, direction = props.direction;
    if (direction === "horizontal") {
        return (_jsx(Divider, { id: id, orientation: direction, sx: {
                width: "inherit",
                //magin
                margin: props.margin || "0.125rem 0",
                marginTop: props.marginTop,
                marginBottom: props.marginBottom,
                marginLeft: props.marginLeft,
                marginRight: props.marginRight,
                marginX: props.marginX,
                marginY: props.marginY,
                //border
                borderWidth: "0.0625rem",
                borderColor: Color.component.gray_02,
            } }));
    }
    if (direction === "vertical") {
        return (_jsx(Divider, { orientation: direction, flexItem: true, sx: {
                //margin
                margin: props.margin || "0 0.125rem",
                marginTop: props.marginTop,
                marginBottom: props.marginBottom,
                marginLeft: props.marginLeft,
                marginRight: props.marginRight,
                marginX: props.marginX,
                marginY: props.marginY,
                //border
                borderWidth: "0.0625rem",
                borderColor: Color.component.gray_02,
            } }));
    }
    return _jsx(Typography, { children: "direction is not available" });
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
